import apiFetch from '../apiFetch'

export default function (idVehiculo, token) {
  return apiFetch({endPoint: `Transportista/comprobarEliminacionVehiculo?idVehiculo=` + idVehiculo, method: 'GET', body: null, token: token})
}